export default __webpack_public_path__ + "media/images/landing-15-550x420-366d7d790e6a923e3435a1a6cbe553f1.jpg";